import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {PagerService} from 'app/common/services/Pagination.service';
import {ImageService} from 'app/pages/imageService';
import * as moment from 'moment';
import {IOption} from 'ng-select';
import {BsModalService, ModalDirective} from 'ngx-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {Subscription} from 'rxjs';
import {IntegrateSelloutServices} from './services/inegrate-sellout.services';
import {environment} from '../../../../../environments/environment';
import {TranslateService} from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'app-integrate-sellout',
  templateUrl: './integrate-sellout.component.html',
  styleUrls: ['./integrate-sellout.component.css'],
  providers: [IntegrateSelloutServices],
})
export class IntegrateSelloutComponent implements OnInit {

  @ViewChild('pauseCampaign') pauseCampaign: ModalDirective;
  @ViewChild('activeCampaign') activeCampaign: ModalDirective;
  @ViewChild('removeCampaign') removeCampaign: ModalDirective;

  has_list: boolean = true;
  params: any = {};

  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';

  public current_filter: any = {};
  public list_items: any = [];
  public item_detail: any = {};
  public FormFilterSellout: FormGroup;

  public pager: any;
  public pageIndex: number = 1;
  public page_size: number = 10;
  public totalRow: number = 0;
  public total_data_history: number = 0
  public errorMessage: string = '';

  public item_active: number = 0;
  loadingDetail: boolean = false;

  /** Config status */

  sellout_actived = 1;
  sellout_pause = 0;

  list_status_filter: Array<IOption> = [
    {value: this.sellout_actived.toString(), label: 'Kích hoạt'},
    {value: this.sellout_pause.toString(), label: 'Tạm dừng'},
  ];

  /** Config service */
  code_chonggia = 1;
  code_baohanh = 2;
  code_tranhang = 3;
  code_dinhdanh = 5;

  subcribe: Subscription = null;
  isCrating: Boolean = false;
  isUpdate: Boolean = false;

  constructor(
    private integrateSelloutService: IntegrateSelloutServices,
    private fb: FormBuilder,
    private imageService: ImageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private pagerService: PagerService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private translate: TranslateService
  ) {
    this.subcribe = this.modalService.onHide.subscribe(() => {
      this.viewDetail(this.item_active);
      // this.excel = {};
      // this.fileExcel = null;
      // this.numberStamp = null;
      // if (this.isImporting == false) {
      //     this.viewDetail(this.item_active)
      // }
      // this.isImporting = false;
    });

    this.translate.onLangChange.subscribe(() => {
      this.updateTranslations();
    });
  }

  updateTranslations() {
    this.list_status_filter = [
      {value: this.sellout_actived.toString(), label: this.translate.instant('KICH_HOAT')},
      {value: this.sellout_pause.toString(), label: this.translate.instant('TAM_DUNG')},
    ];

    this.list_status_integrate = [
      { value: this.campaign_active.toString(), label: this.translate.instant('KICH_HOAT') },
      { value: this.campaign_pause.toString(), label: this.translate.instant('TAM_DUNG') },
      { value: this.campaign_deleted.toString(), label: this.translate.instant('DA_GO') },
    ];

    $('#integrate_status').select2({
      placeholder: this.translate.instant('TRANG_THAI_TICH_HOP'),
      allowClear: false,
      minimumResultsForSearch: -1,
    });
    $('#status').select2({
      placeholder: this.translate.instant('TRANG_THAI'),
      allowClear: false,
      minimumResultsForSearch: -1,
    });
    $('.slt-batchstamp').select2({
      placeholder: this.translate.instant('TIM_KIEM_LO_TEM'),
      allowClear: true,
      minimumInputLength: 2,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/batches`,
        headers: {
          authorization: `${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          $('.select2-container').addClass('setIndex-1800');
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 150,
              show_parent_child: 1,
            };
          }
          return {
            offset: 0,
            limit: 150,
            show_parent_child: 1,
          };
        },
        processResults: function (data) {
          return {
            results:
              data.data && data.data.batches
                ? data.data.batches.map((item) => {
                  return {
                    text: item.name,
                    id: item.id,
                  };
                })
                : [],
          };
        },
      },
    });

    $('.slt-campaign').select2({
      placeholder: this.translate.instant('TEN_CHUONG_TRINH'),
      allowClear: true,
      ajax: {
        delay: 1000,
        url: `${environment.qrcode_url_aps}/v1/sale_out/settings/campaigns`,
        headers: {
          authorization: `${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          $('.select2-container').addClass('setIndex-1800');
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 150,
              show_parent_child: 1,
            };
          }
          return {
            offset: 0,
            limit: 150,
            show_parent_child: 1,
          };
        },
        processResults: function (data) {
          return {
            results:
              data.data && data.data.batches
                ? data.data.batches.map((item) => {
                  return {
                    text: item.name,
                    id: item.id,
                  };
                })
                : [],
          };
        },
      }
    });

    if(!this.has_list && this.total_data_history == 0 && this.isLink){
        this.errorMessage = this.translate.instant('KHONG_CO_DU_LIEU');
    }
  }

  ngOnInit() {
    this.updateTranslations();
    $('.selectpicker').selectpicker({
      style: 'btn-select',
      iconBase: 'icon',
      tickIcon: 'wb-check',
    });

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.params.status = params.status;
      this.loadData(this.params);
    });
    this.createFormFilter();
    this.createFormCampaign();
  }

  createFormFilter() {
    this.FormFilterSellout = this.fb.group({
      // service: [[]],
      status: [this.params.status],
      created_time_ranger: [null],
      serial: [null],
    });
  }

  public isLink = false;

  public loadData(request: any = null) {

    let data_get: any = request ? request : this.current_filter;
    data_get.page = this.pageIndex;
    data_get.size = this.page_size;

    this.integrateSelloutService.selloutHistory(data_get)
      .toPromise()
      .then((res: any) => {
        if (res.code === 1) {
          this.total_data_history = res.data.pagination.totalElements;
          let list: any = [];
          let serial = '';
          for (let _data of res.data.items) {
            if (_data.idStart === _data.idEnd) {
              serial = this.formatSerial(_data.idStart, _data.prefix.toUpperCase())
            } else {
              serial = this.formatSerial(_data.idStart, _data.prefix.toUpperCase())
                + '-->' +
                this.formatSerial(_data.idEnd, _data.prefix.toUpperCase())
            }
            let obj = {
              id: _data.id,
              serial: serial,
              prefix: _data.prefix,
              idStart: _data.idStart,
              idEnd: _data.idEnd,
              campaignName: _data.campaignName,
              productName: _data.productName,
              createdAt: _data.createdAt,
              status: _data.status,
              image: this.imageService.readSrcImage(_data.productImage, 'thumb_large'),
            };
            list.push(obj);
          }
          this.list_items = list;
          console.log('do dai', list.length)
          this.item_active = 0
          if (list.length > 0) {
            this.has_list = true;
            this.isLink = true
            this.viewDetail(0);
          } else {
            this.has_list = false;
            this.item_detail = null;
            this.isLink = true
          }
        } else {
          this.errorMessage = res.message
          this.has_list = false;
          this.item_detail = null;
        }
      })
      .catch((err: any) => {
        console.log('getlistSellout:catch 123123', err);
      })
  }

  prePageList() {
    if (this.pageIndex > 1) {
      this.pageIndex = this.pageIndex - 1;
      // this.loading_left = true;
      this.loadData();
    }
  }

  lastPageList() {
    // console.log('res.items', this.pageIndex * this.page_size, this.total_data )
    // if (this.pageIndex * this.page_size < this.total_data) {
    this.pageIndex = this.pageIndex + 1;
    // this.loading_left = true;
    this.loadData();
    // }
  }

  inputPageList(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndex) {
      this.pageIndex = page;
      // this.loading_left = true;
      this.loadData();
    }
  }

  convertServiceToText(service: string) {
    let arr_services: Array<{ code: number; name: string }> = [];
    if (service.indexOf(this.code_chonggia.toString()) != -1) {
      arr_services.push({code: this.code_chonggia, name: 'DICH_VU_CHONG_GIA'});
    }
    if (service.indexOf(this.code_baohanh.toString()) != -1) {
      arr_services.push({code: this.code_baohanh, name: 'DICH_VU_BAO_HANH'});
    }
    if (service.indexOf(this.code_tranhang.toString()) != -1) {
      arr_services.push({code: this.code_tranhang, name: 'TRAN_HANG_1'});
    }
    if (service.indexOf(this.code_dinhdanh.toString()) != -1) {
      arr_services.push({code: this.code_dinhdanh, name: 'DICH_VU_INH_DANH'});
    }
    return arr_services;
  }

  formatSerial(id: any, prefix: string) {
    let serial_f = '';
    id = id.toString();
    if (id && prefix) {
      const pad = '000000';
      const serial = pad.substring(0, 6 - id.length) + id;
      serial_f = prefix + '-' + serial;
    }
    return serial_f;
  }

  async viewDetail(i) {
    this.item_active = i;
    // this.loadingDetail = true;
    if (this.isCrating == true || this.isUpdate == true) {
      this.toastr.warning(this.translate.instant('THAO_TAC_GAN_CHUONG_TRINH_BI_HUY'), this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      });
    }
    $('.page-layout-detail').animate(
      {scrollTop: 0},
      0,
      'swing',
      function () {
      }
    );
    this.isCrating = false;
    this.isUpdate = false;

    // Pass parameter for new api
    let query = {
      prefix: this.list_items[i].prefix,
      id_start: this.list_items[i].idStart,
      id_end: this.list_items[i].idEnd
    };

    await this.integrateSelloutService
      .selloutDetail(query)
      .toPromise()
      .then((res: any) => {

        if (res.code == 1) {
          this.clearCheckBox();
          this.resetFormCampaign();
          let serial = '';

          setTimeout(() => {
            $('#integrate_status').select2({
              placeholder: this.translate.instant('TRANG_THAI_TICH_HOP'),
              allowClear: false,
              minimumResultsForSearch: -1,
            });
          }, 1)

          if (res.data.idStart === res.data.idEnd) {
            serial = this.formatSerial(res.data.idStart, res.data.prefix.toUpperCase())
          } else {
            serial = this.formatSerial(res.data.idStart, res.data.prefix.toUpperCase())
              + '-->' +
              this.formatSerial(res.data.idEnd, res.data.prefix.toUpperCase())
          }

          this.item_detail = {
            batchCreatedAt: res.data.batchCreatedAt,
            batchName: res.data.batchName,
            idEnd: res.data.idEnd,
            idStart: res.data.idStart,
            prefix: res.data.prefix,
            productImage: this.imageService.readSrcImage(
              res.data.productImage,
              'thumb_medium'
            ),
            productName: res.data.productName,
            arr_services: this.convertServiceToText(res.data.services),
            serial: serial,
          }
        } else {
          this.errorMessage = res.message;
          console.log('getSelloutDetail:error', res);
        }
      })
      .catch((err) => {
        console.log('getSelloutDetail:catch', err);
      });

    this.campaign_filter = {};
    this.getSelloutCampaigns();
  }

  submitFilterSellout(data: any = {}) {
    this.pageIndex = 1;
    let data_filter: any = {};

    if (data.service && data.service.length > 0) {
      data_filter.service = data.service.toString();
    }

    if (data.serial) {
      data_filter.serial = data.serial;
    }
    if ($('#status').val()) {
      data_filter.status = $('#status').val();
    }
    if (data.created_time_ranger) {
      data_filter.from = moment(data.created_time_ranger[0]).format(
        'DD-MM-YYYY'
      );
      data_filter.to = moment(data.created_time_ranger[1]).format('DD-MM-YYYY');
    }
    if ($('.slt-batchstamp').val()) {
      data_filter.batch_id = $('.slt-batchstamp').val();
    }

    this.current_filter = data_filter;
    this.loadData();
  }

  ResetFormSearch() {
    $('#filter_service').selectpicker('val', '');
    $('#status').val('').trigger('change');
    $('.slt-batchstamp').val('').trigger('change');
    this.FormFilterSellout.reset();
  }

  handlePauseCampaign() {
    let body = {
      logIds: this.list_id,
      status: 0
    }
    this.integrateSelloutService.updateSelloutCampaign(body)
      .toPromise()
      .then((res: any) => {
        if (res.code === 1) {
          this.toastr.success(this.translate.instant('TAM_DUNG_CHUONG_TRINH_THANH_CONG'), this.translate.instant('THONG_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          this.pauseCampaign.hide();
          this.getSelloutCampaigns();
          this.clearCheckBox();
          return;
        } else {
          this.toastr.warning(`${res.message}`, this.translate.instant('THONG_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right'
          })
        }
      })
      .catch((err) => {
        this.toastr.warning(err.message, this.translate.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      })

  }


  handleActiveCampaign() {
    let body = {
      logIds: this.list_id,
      status: 1
    }
    console.info("id: ", this.list_id);

    this.integrateSelloutService.updateSelloutCampaign(body)
      .toPromise()
      .then((res: any) => {
        if (res.code === 1) {
          this.toastr.success(this.translate.instant('KICH_HOAT_CHUONG_TRINH_THANH_CONG'), this.translate.instant('THONG_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          this.activeCampaign.hide();
          // this.loadData()
          this.getSelloutCampaigns();
          this.clearCheckBox();
          return;
        } else {
          this.toastr.warning(`${res.message}`, this.translate.instant('THONG_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right'
          })
        }
      })
      .catch((err) => {
        this.toastr.warning(err.message, this.translate.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      })

  }

  handleRemoveCampaign() {
    let query = {
      logIds: this.list_id,
    };

    this.integrateSelloutService.removeSelloutCampaign(query)
      .toPromise()
      .then((res: any) => {
        if (res.code === 1) {
          this.toastr.success(this.translate.instant('GO_CHUONG_TRINH_THANH_CONG'), this.translate.instant('THONG_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          this.removeCampaign.hide();
          // this.loadData()
          this.getSelloutCampaigns();
          this.clearCheckBox();
          return;
        } else {
          this.toastr.warning(`${res.message}`, this.translate.instant('THONG_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right'
          })
        }
      })
      .catch((err) => {
        this.toastr.warning(err.message, this.translate.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      })

  }

  showUpdate() {
    this.isUpdate = true;
    this.isCrating = false;

  }

  hideUpdate(event) {
    setTimeout(() => {
      $('#integrate_status').select2({
        placeholder: this.translate.instant('TRANG_THAI_TICH_HOP'),
        allowClear: false,
        minimumResultsForSearch: -1,
      });
    }, 1)

    console.log("123123123")

    this.isUpdate = false;
    this.isCrating = false;
    this.viewDetail(this.item_active);
  }

  showCrating() {
    this.isCrating = true;
    // this.isCreate = false;
    this.isUpdate = false;
    // this.isDistribution = false;
    // this.isActive = false;
  }

  hideCrating(event) {
    console.log("select2", $('#integrate_status'));

    setTimeout(() => {
      $('#integrate_status').select2({
        placeholder: this.translate.instant('TRANG_THAI_TICH_HOP'),
        allowClear: false,
        minimumResultsForSearch: -1,
      });
    }, 1)

    console.log(event)
    // this.isCreate = false;
    this.isCrating = false;
    this.isUpdate = false;
    if (event.isBack == false) {
      // delete this.arr_sort['created_time'];
      // this.setSort('created_time', 'desc');
      this.current_filter = {};
      this.pageIndex = 1;
      this.loadData();
    }
    if (event.updated == true) {
      this.viewDetail(this.item_active);
    }
  }

  // TuanHA: Form Filter Campaigns

  public total_data_campaigns: number = 0;

  pageCampaignIndex: number = 1;
  pageCampaignSize: number = 10;

  prePageCampaignList() {
    if (this.pageCampaignIndex > 1) {
      this.pageCampaignIndex = this.pageCampaignIndex - 1;
      this.getSelloutCampaigns();
    }
  }

  lastPageCampaignList() {
    this.pageCampaignIndex = this.pageCampaignIndex + 1;
    this.getSelloutCampaigns();
  }

  inputPageCampaignList(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageCampaignIndex) {
      this.pageCampaignIndex = page;
      this.getSelloutCampaigns();
    }
  }

  campaign_active = 1;
  campaign_pause = 0;
  campaign_deleted = 2;

  list_status_integrate: Array<IOption> = [
    { value: this.campaign_active.toString(), label: 'Kích hoạt' },
    { value: this.campaign_pause.toString(), label: 'Tạm dừng' },
    { value: this.campaign_deleted.toString(), label: 'Đã gỡ' },
  ];

  public FormFilterCampaigns: FormGroup;
  public campaigns: any = [];
  public campaign_filter: any = {};
  isCheckAll = false;
  listOfChecked = {};
  list_id = [];

  listIdChecked() {
    for (const key in this.listOfChecked) {
      if (this.listOfChecked[key] === true) {
        if (!this.list_id.includes(key)) {
          this.list_id.push(key);
        }
      } else {
        if (this.list_id.includes(key)) {
          this.list_id.splice(this.list_id.indexOf(key), 1);
        }
      }
    }
  }

  activeCampaignsSellout() {
    this.activeCampaign.show();
  }

  pauseCampaignsSellout() {
    this.pauseCampaign.show();
  }

  removeCampaignsSellout() {
    this.removeCampaign.show();
  }

  list_status = [];

  checkAllCampaignsStatus(status: number) {
    this.list_status = [];
    if (this.list_id.length !== 0) {
      this.list_id.forEach(idc => {
        this.list_status.push(this.campaigns.find(c => c.id == idc).status);
      });
    }
  }

  checkAll(event) {
    this.isCheckAll = event.target.checked;
    if (this.isCheckAll) {
      this.campaigns.map((item) => {
        this.listOfChecked[item.id] = true;
      });
      this.listIdChecked();
      this.checkAllCampaignsStatus(0);
      return;
    }
    this.campaigns.map((item) => {
      this.listOfChecked[item.id] = false;
      this.listIdChecked();
    });
    this.checkAllCampaignsStatus(0);
  }

  checkBoxChange(event) {
    const checked = event.target.checked;
    const value = event.target.value;
    this.listOfChecked[value] = checked;
    this.isCheckAll = this.campaigns.every(
      (item) => this.listOfChecked[item.id]
    );
    this.listIdChecked();
    this.checkAllCampaignsStatus(0);
    console.info("list id: ", this.list_id);
  }

  clearCheckBox() {
    this.isCheckAll = false;
    this.listOfChecked = {};
    this.list_id = [];
  }

  createFormCampaign() {
    this.FormFilterCampaigns = this.fb.group({
      campaign_name: [null],
      integrate_status: [null],
      integrate_time: [null]
    });
  }

  getSelloutCampaigns() {
    this.params = {
      prefix: this.item_detail.prefix,
      id_start: this.item_detail.idStart,
      id_end: this.item_detail.idEnd,
      page: this.pageCampaignIndex,
      size: this.pageCampaignSize,
      ...this.campaign_filter,
    }

    console.info('filter query: ', this.params);

    this.integrateSelloutService
      .getSelloutCampaigns(this.params)
      .toPromise()
      .then((res: any) => {
        if (res.code === 1) {

          this.total_data_campaigns = res.data.pagination.totalElements;
          let list: any = [];
          res.data.items.forEach(item => {
            list.push({
              id: item.id,
              status: item.status,
              campaignCreatedAt: item.campaignCreatedAt,
              campaignCode: item.campaignCode,
              campaignId: item.campaignId,
              campaignImage: this.imageService.readSrcImage(
                item.campaignImage,
                'thumb_medium'
              ),

              campaignName: item.campaignName,
              campaignStatus: item.campaignStatus,
            });

          });
          this.campaigns = list;
        } else {
          this.errorMessage = res.message;
          this.campaigns = []
        }
      })
      .catch((err) => {
        console.log('getSelloutDetail:catch', err);
      });
  }

  submitFilterCampaign(data: any) {
    console.info('Form data; ', data);
    this.pageCampaignIndex = 1;
    let data_filter: any = {};

    if (data.campaign_name && data.campaign_name.length > 0) {
      data_filter.campaign_name = data.campaign_name;
    }
    if ($('#integrate_status').val()) {
      data_filter.status = $('#integrate_status').val();
    }
    if (data.integrate_time) {
      data_filter.from = moment(data.integrate_time[0]).format('DD-MM-YYYY');
      data_filter.to = moment(data.integrate_time[1]).format('DD-MM-YYYY');
    }

    this.campaign_filter = data_filter;
    this.getSelloutCampaigns();
  }

  resetFormCampaign() {
    $('#campaign_name').val('').trigger('change');
    $('#integrate_status').val('').trigger('change');
    $('#integrate_time').selectpicker('val', '');
    this.FormFilterCampaigns.reset();
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/integrate-sellout/integrate-sellout.component.ts